module.exports = __webpack_public_path__ + "img/dgii-newlogo.68d57ee8.png";